export const stats = {
  general: {
    filter: {
      group_by: {
        title: 'Group by',
        value: {
          // day: 'Day',
          // week: 'Week',
          month: 'Month',
          country: 'Country'
        }
      },

      status: {
        title: 'Status'
      },

      country: {
        title: 'Country'
      },

      number: {
        title: 'Number'
      }
    },

    cell: {
      fee: '0 fee | {count} fee | {count} fees'
    },

    field: {
      min_date: 'Date start',
      max_date: 'Date end',
      number_count: 'Count numbers',
      country: 'Country',
      number: 'Number',
      month: 'Month',
      average_subscription_fee: 'Average subscription fee per number in period',
      connection_cost_sum: 'Paid for connecting numbers for the period',
      subscription_fee_sum: 'Paid for subscription fee for the period',
      total: 'Total',
    
    }
  },

  detailed: {
    field: {
      payment_sum: 'Paid for number in period',
      current_status: 'Current status',
      subscription_fee_count: 'Number of deductions for subscription fee in period',
      last_payment_date: 'Date of last deduction',
      total: 'Total {count}'
    },
    tooltip: {
      sum: 'Sum of all payments for subscription fee and for connecting a number.'
    }
  }
};
